import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleKeywordWhatCountry extends TitleBase {
	protected canHandle(): boolean {
		return (
			this.indexableFilters.length >= 2 &&
			this.multiValueFilters.length >= 0 &&
			this.indexableFilters.some((_) => _.type === ParameterType.KEYWORD_WHAT) &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			!this.indexableFilters.some((_) => _.type === ParameterType.KEYWORD_WHERE)
		);
	}

	protected getPageTitle(): string {
		const keywordWhatValue = this.getFilterValue(ParameterType.KEYWORD_WHAT);
		const countryValue = this.getFilterValue(ParameterType.COUNTRY);

		return `"${keywordWhatValue}" ${this.titlePortalType} in ${countryValue}`;
	}
}
